import { VectorMeta } from "@nens/rana/api-v1";

import type { SelectedFileOrLayer } from "../features/map-layers";
import { CompleteFile } from "../types/file-reference-with-file";

export function getFilePath(file: CompleteFile): string {
  return file.path;
}

export function getFileName(file: CompleteFile): string {
  if (file.name) return file.name;
  const pathParts = file.path.split("/");
  return pathParts[pathParts.length - 1];
}

export function getFileLayers(file: CompleteFile): SelectedFileOrLayer[] {
  if (file.file.descriptor.dataType === "scenario") {
    // For scenarios, take the layers from the descriptor directly, not from meta.
    return (file.file.descriptor.layers || []).map((layer) => ({
      file,
      layerInFile: layer.id,
      name: layer.name,
    }));
  } else if (file.file.descriptor.dataType === "vector") {
    return (
      (file.file.descriptor.meta as VectorMeta)?.layers.map((layer) => ({
        file,
        layerInFile: layer.id,
        name: layer.name,
      })) || []
    );
  } else if (file.file.descriptor.dataType === "raster") {
    // For raster files, we add the file itself as a "layer", since there are no layers in raster files.
    return [
      {
        file,
        name: getFileName(file),
      },
    ];
  } else {
    // For other file types, we don't know how to get layers, so return an empty array.
    return [];
  }
}
